import { useState, useCallback, useEffect } from 'react';
import './App.css';
import { Unity, useUnityContext } from 'react-unity-webgl';
import { ThemeProvider } from 'styled-components';
import defaultTheme from './theme';

import './Native/unity-webgl-tools.js';
import './Native/microphone.js';
import { ShareIcon } from './svg';
import { ArrowIcon } from './svg';
import cybertwin_logo from './cybertwin_logo.png';
import { useFGFileBrowser, useGetSpaceInfo, useDynamicTheme } from './hooks';
import { reloadWindow } from './utils/window';
import {
    SharePage,
    FilePickerModal,
    LoginForm,
    CircularLoader,
} from './components';

import styled from 'styled-components';
import getSpacePreview from './hooks/useGetSpacePreview.js';
import getCompanyLogo from './hooks/getCompanyLogo.js';
import getTokenWithKey from './hooks/useGetTokenWithKey.js';
import verifyNewUser from './hooks/verifyAccount.js';
import { bool } from 'prop-types';
const unityConfig = getUnityConfig(process.env.NODE_ENV);
const ShareSpaceButton = styled(ShareIcon)`
    color: ${({ theme }) => theme.color.highlightColor};
`;

const ShareIconButton = styled.button`
    background: white;
    padding: 10px;
    border-radius: 50%;

    :hover {
        background: ${({ theme }) => theme.color.highlightColor};
    }

    :hover ${ShareSpaceButton} {
        color: #fff;
    }
`;

const LoadedArrowIcon = styled(ArrowIcon)`
    color: ${({ theme }) => theme.color.highlightColor};
`;

function getUnityConfig(nodeEnv) {
    const devSettings = {
        dataUrl: 'Build/Webgl.data',
        frameworkUrl: 'Build/Webgl.framework.js',
        codeUrl: 'Build/Webgl.wasm',
        symbolsUrl: 'Build/Webgl.symbols.json',
    };

    const prodSettings = {
        dataUrl: 'Build/Webgl.data.br',
        frameworkUrl: 'Build/Webgl.framework.js.br',
        codeUrl: 'Build/Webgl.wasm.br',
        symbolsUrl: 'Build/Webgl.symbols.json.br',
    };

    return {
        ...(nodeEnv === 'development' ? devSettings : prodSettings),
        loaderUrl: 'Build/Webgl.loader.js',
        streamingAssetsUrl: 'StreamingAssets',
        companyName: 'CyberTwin',
        productName: 'CyberTwin',
        productVersion: '3'
    };
}

function App() {

    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [showVerified, setShowVerified] = useState(false);
    const [showStandardModal, setShowStandardModal] = useState(true);
    // When a user has authenticated, this is used to say if a user can edit a space or not.
    const [authenticated, setAuthenticated] = useState(false);
    // When a user has authenticated, this is used to say if a user can edit a space or not. 
    const [userIsAnEditor, setUserAsAnEditor] = useState(false);
    var alreadySearchedPublicKey = false;
    // This value is loaded from a space Path and declares the name of a space once loaded 
    var userEmail = "null";
    // This value is loaded from a space Path and declares the name of a space once loaded 
    var userPassword = "null";

    // The projectID is used to define a customer and its data. 
    var cyberTwinProjectID = "empty";
    // This is a sub directory of the projectID folder. Sometimes customers will have more than one space. 
    //The id is used to load different spaces once the user has logged in
    var spaceID = "empty";
    // This is a sub directory of the projectID folder. Sometimes customers will have more than one space. 
    //The id is used to load different spaces once the user has logged in
    var unityAppStarted = false;
    var verificationKey = "";
    var forgotPassKey = "";

    // This value is loaded from a space Path and declares the name of a space once loaded
    const [spaceName, setSpaceName] = useState("Space 1");
    // The spaceThumbnails Url
    const [spaceThumbnailUrl, setSpaceThumbnailUrl] = useState("");
    // The spaceThumbnails Url
    const [spaceThumbnailUrlFound, setSpaceThumbnailUrlFound] = useState(false);
    // The url of the logo for the space  
    const [companyLogoUrl, setCompanyLogoUrl] = useState("");
    // The url of the logo for the space  
    const [companyLogoFound, setCompanyLogoFound] = useState(false);
    // The theme applied to the Theme Provider  
    const [theme, setTheme] = useState(defaultTheme);
    // The backup theme applied to the Theme Provider. It is only used if the theme fails to load data
    const [backupTheme, setBackupTheme] = useState(defaultTheme);

    const [sharedKey, setSharedKey] = useState("empty");
    const [loadedKey, setLoadedKey] = useState("empty");
    // Used to toggle the unity app
    const [displayUnityApp, setDisplayUnityApp] = useState(false);
    // Used to toggle the visibility of the Login Screen
    const [displayLogin, setDisplayLogin] = useState(true);
    // The loading progress of the unity app once opened
    const [loadingValueForExternal, setProgressValue] = useState(1);
    // Whether the display share button has been pressed or not
    const [displayShareBtn, setDisplayShareBtn] = useState(false);

    // Unity related variables and event listeners
    const {
        unityProvider,
        isLoaded: unityIsLoaded,
        loadingProgression,
        sendMessage,
        addEventListener,
        removeEventListener,
    } = useUnityContext(unityConfig);

    // FileBrowser Related Variables. The File Browser is used by unity to open files
    const {
        handleHide: fgHandleHide,
        handleFilesSelection: fgHandleFilesSelection,
        filePopupVisible: displayFgFilePopup,
        acceptTypes: fgFileAcceptTypes,
    } = useFGFileBrowser(sendMessage);

    /**
     *
     * Wrapped version of `sendMessage` that always sends to 'React Communication Manager'
     *
     * @param {string} methodName
     * @param {any=} parameter
     *
     */
    const sendMessageComsMgr = useCallback(
        (methodName, parameter) => {
            //////console.log("Message : sendMessage" + methodName);
            return sendMessage(
                'ReactCommunicationManager',
                methodName,
                parameter
            );
        },
        [sendMessage]
    );

    useEffect(() => {
        if (unityIsLoaded) {
            ////////console.log("Engine Loaded");
        }
    }, [unityIsLoaded]);


    /**
     *
     * set all values required to load a space
     *
     * @param {string} userLoginValue
     * @param {number} password,login
     *
     */



    function loadUnitySpaceData() {

        const userx = userEmail.toString();
        const passx = userPassword.toString();
        if (userEmail !== "null") {
            ////////console.log("loadUnitySpaceData = User: " + userx);
            sendMessageComsMgr('SetUsername', userx);
        }
        else {
            ////////console.log("loadUnitySpaceData = User: " + userx);
        }

        if (userPassword !== "null") {
            ////////console.log("loadUnitySpaceData = Pass: " + passx);
            sendMessageComsMgr('SetPassword', passx);
        }
        else {
            ////////console.log("loadUnitySpaceData = Pass: " + pass);
        }
    }



    /**
     *
    * Gets the loading Value Back From Unity when the space loads
     *
     */
    const handleGetProgressValue = useCallback((loadingValueForExternal) => {

        loadingValueForExternal = parseFloat(loadingValueForExternal);
        loadingValueForExternal = Math.trunc(loadingValueForExternal);
        loadingValueForExternal = loadingValueForExternal + 1;
        if (loadingValueForExternal <= 99) {
            setProgressValue(loadingValueForExternal);
        } else {
            loadingValueForExternal = 100;
            setProgressValue(loadingValueForExternal);
        }
    }, []);

    useEffect(() => {
        addEventListener('GetProgressValue', handleGetProgressValue);
        return () => {
            removeEventListener('GetProgressValue', handleGetProgressValue);
        };
    }, [addEventListener, removeEventListener, handleGetProgressValue]);




    /**
    *
    * When the share button is clicked
    *
    */
    const handleShareBtnClicked = useCallback(() => {

        setDisplayShareBtn(true);
    }, []);

    useEffect(() => {
        addEventListener('shareBtnClicked', handleShareBtnClicked);
        return () => {
            removeEventListener('shareBtnClicked', handleShareBtnClicked);
        };
    }, [addEventListener, removeEventListener, handleShareBtnClicked]);

    /**
    *
    * When the share button is clicked
    *
    */
    const appStarted = useCallback(() => {
        console.log("Message : CyberTwin Engine Started");
        unityAppStarted = true;

    }, []);

    useEffect(() => {
        addEventListener('appStarted', appStarted);
        return () => {
            removeEventListener('appStarted', appStarted);
        };
    }, [addEventListener, removeEventListener, appStarted]);


    /**
    *
    * Shows the unity game view if user switches tab
    *
    */

    const handleDocumentHiddenStatusChange = () => {
        if (unityAppStarted) {
            if (document.hidden) {
                ////////console.log("document.nothidden");
                sendMessageComsMgr('sendDocumentHiddenStatusToUnity', 1);
            } else {
                ////////console.log("document.hidden");
                sendMessageComsMgr('sendDocumentHiddenStatusToUnity', 0);
            }
        }
        else {
            ////////console.log("App Has Not Started, aborted check");
        }
    };

    useEffect(() => {

        document.addEventListener(
            'visibilitychange',
            handleDocumentHiddenStatusChange
        );

        return () => {
            window.removeEventListener(
                'visibilitychange',
                handleDocumentHiddenStatusChange
            );
        };
    }, []);

    const reloadingApp = useCallback((message) => {
        reloadWindow();
    }, []);
    /**
            *
            * Reload App
            *
            */
    useEffect(() => {
        addEventListener('reloadApp', reloadingApp);
        return () => {
            removeEventListener('reloadApp', reloadingApp);
        };
    }, [addEventListener, removeEventListener, reloadingApp]);



    /**
        *
        * When the back button is clicked
        *
        */
    useEffect(() => {
        addEventListener('backBtnClicked', reloadWindow);
        return () => {
            removeEventListener('backBtnClicked', reloadWindow);
        };
    }, [addEventListener, removeEventListener]);


    /**
        *
        * When the share button is clicked
        *
        */
    const keyGenerated = useCallback((key) => {
        setSharedKey(key);
        ////////console.log("Message : KeyGenerated => " + sharedKey);
        handleShareBtnClicked(key);
    }, []);

    useEffect(() => {
        addEventListener('keyGenerated', keyGenerated);
        return () => {
            removeEventListener('keyGenerated', keyGenerated);
        };
    }, [addEventListener, removeEventListener, keyGenerated]);


    const loginBackGroundStyles = {
        opacity:
            spaceThumbnailUrlFound
                ? '1'
                : '0',
        background: spaceThumbnailUrl
            ? `linear-gradient(90deg, rgba(255, 255, 255, 0.95) 49.999%, rgba(255, 255, 255, 0) 50%), url(${spaceThumbnailUrl}) no-repeat center center/cover`
            : 'white',
    };


    /**
        *
        * Called when the User has entered a public key.  
        *
        */
    function userHasAuthenticatedKey(newSpaceID, newProjectID, spaceKey, logoKey, previewKey) {

        ////////console.log("Message : userHasAuthenticatedKey");
        cyberTwinProjectID = newProjectID;
        spaceID = newSpaceID;
        setDisplayLogin(false);
        setAuthenticated(true);
        setUserAsAnEditor(false);

        ////////console.log("User is Authenticated With Key");
        if (newProjectID !== null) {

            ////////console.log("Load single space....");
            loadSingleSpace(newProjectID, spaceID, spaceKey, logoKey, previewKey);
        }

    }



    /**
    *
    * Called when the User has entered a valid username and password in Login. 
    * Triggered when the user clicks the Submit Button and the user is authenticated
    *
    */
    function userHasAuthenticated(newUuserEmail, newUserPassword, newProjectID, role, spaceKey, logoKey, previewKey) {

        ////////console.log("Message : userHasAuthenticated");
        cyberTwinProjectID = newProjectID;
        spaceID = "0";
        setDisplayLogin(false);
        setAuthenticated(true);

        if (role === "Owner") {
            setUserAsAnEditor(true);
            ////////console.log("The user has editor privellages");

        }
        else if (role === "Editor") {
            setUserAsAnEditor(true);
            ////////console.log("The user has editor privellages");

        }
        else if (role === "Admin") {
            setUserAsAnEditor(true);
            ////////console.log("The user has editor privellages");

        }
        else {
            setUserAsAnEditor(false);
            ////////console.log("The user user is read only privellages");
        }

        ////////console.log("User is Authenticated");
        if (newProjectID !== null) {
            userEmail = newUuserEmail;
            userPassword = newUserPassword;
            ////////console.log("newUserPassword: " + userPassword);
            ////////console.log("userEmail: " + userEmail);
            loadSpaceViewer();
        }
        else {
            console.log("No working project id found");
        }

    }

    /**
    *
   * Loading of theme colors
   *
   */
    function loadSpaceViewer() {
        ////////console.log("Message : loadSpaceViewer");
        loadUnitySpaceData();
        showUnityApp();

    }


    /**
     *
    * Loading of theme colors
    *
    */
    function loadSingleSpace(newProjectID, spaceID, spaceKey, logoKey, previewKey) {

        ////////console.log("Message : loadSingleSpace");
        ////////console.log("loadSingleSpace with id " + spaceID);
        useGetSpaceInfo(newProjectID, spaceID, spaceKey, logoKey, previewKey, updateTheme);
    }


    /**
    *
    * Implementation of loaded theme colours 
    *
    */
    async function updateTheme(
        spaceNotSetup,
        logoKey,
        previewKey,
        spaceName,
        navigationColor,
        highlightColor) {

        ////////console.log("Message : updateTheme");
        ////////console.log("updateTheme : spaceNotSetup " + spaceNotSetup);

        if (spaceName === "Null") {
            ////////console.log("Values were not loaded in successfully");
            return;
        }
        else {
            ////////console.log("Data has been loaded, now updating colours...");
        }


        getCompanyLogo(logoKey, logoDownloaded);
        getSpacePreview(previewKey, previewDownloaded);
        setSpaceThumbnailUrl(spaceThumbnailUrl);
        setSpaceName(spaceName);

        // theme loaded and backup
        const { loadedTheme, backupTheme } = useDynamicTheme(
            defaultTheme,
            navigationColor,
            highlightColor
        );

        // Come back here later to load in theme colours;
        setTheme(defaultTheme);
        // Come back here later to set default theme colours;
        setBackupTheme(defaultTheme);
        //loadUnitySpaceData();
    }


    /**
    *
    * Called when the space thumbnail is downloadd
    *
    */
    function previewDownloaded(url) {
        ////////console.log("Message : previewDownloaded");
        setSpaceThumbnailUrl(url);
        ////////console.log("Preview Found : " + url);
        setSpaceThumbnailUrlFound(true);
    }


    /**
    *
    * Called when the logo is downloaded
    *
    */
    function logoDownloaded(url) {

        ////////console.log("Message : logoDownloaded");
        setCompanyLogoUrl(url);
        ////////console.log("Logo Found : " + url);
        setCompanyLogoFound(true);
    }

    /**
    *
    * Called when the User presses teh edit button 
    *
    */
    function editModeActivated() {
        ////////console.log("Message : editModeActivated");
        sendMessageComsMgr('EditorToggle', 1);
        showUnityApp();
    }



    /**
    *
    * Displays the unity player
    *
    */
    const showUnityApp = () => {
        ////////console.log("Message : showUnityApp");
        setDisplayUnityApp(true);
    };


    useEffect(() => {

        var showStandard = true;
        //////console.log("Message : URLSearchParams");
        if (!alreadySearchedPublicKey) {
            alreadySearchedPublicKey = true;
            ////////console.log("Message : URLSearchParams");
            // Check the URL for the publicKey query parameter
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const publicKeyQuery = urlParams.get('publicKey')
                if (publicKeyQuery) {
                    const publickey = publicKeyQuery; // Get the publicKey query parameter 
                    setLoadedKey(publickey);
                    showStandard = false;
                    setDisplayLogin(false);
                    //////console.log("Checking public key is " + publickey);
                    getTokenWithKey(publickey, "", userHasAuthenticatedKey)
                }
            }
            catch {
            }

        }

        // Check the URL for the publicKey query parameter
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const forgotPassKeyQuery = urlParams.get('forgotpassword')
            if (forgotPassKeyQuery) {
                forgotPassKey = forgotPassKeyQuery;
                showStandard = false;
                //////console.log("Checking ver key is " + forgotPassKeyQuery);
                setShowForgotPassword(true);
            }

        }
        catch {
        }// Check the URL for the publicKey query parameter
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const verKeyQuery = urlParams.get('ver')
            if (verKeyQuery) {
                verificationKey = verKeyQuery;
                showStandard = false;
                //////console.log("Checking ver key is " + verificationKey);
                setShowVerified(true);
            }

        }
        catch {
        }

        setShowStandardModal(showStandard);
    }, [appStarted, setDisplayLogin, setDisplayUnityApp]);


    // Run once when the component mounts
    /**
        *
       * Called when the User presses the enter space/play button
       *
       */
    function handlePlayBtn(event) {

        showUnityApp();

        ////////console.log("Key is " + loadedKey + ", loading with key");
        const valueToSend = loadedKey.toString();
        sendMessageComsMgr('LoadSpaceKey', loadedKey);

        event.preventDefault();
    }

    function userClickedForgotPasswordLink() {
        setDisplayUnityApp(true);
        setDisplayLogin(false);
        sendMessageComsMgr('ForgotPasswordClicked');
    }
    function userVerifed(value) {
        if (value === true) {
            setDisplayUnityApp(true);
            setDisplayLogin(false);
            const urlParams = new URLSearchParams(window.location.search);
            const verKeyQuery = urlParams.get('ver')
            sendMessageComsMgr('VerifyUser', verKeyQuery);
        }
    }
    function userComfirmPassChange(value) {
        if (value === true) {
            setDisplayUnityApp(true);
            setDisplayLogin(false);
            const urlParams = new URLSearchParams(window.location.search);
            const forgotPassFKey = urlParams.get('forgotpassword')
            sendMessageComsMgr('OpenPasswordResetFromBrowser', forgotPassFKey);
        }
    }

    /**
     *
     * React Display ELements
     *
     */
    return (
        <ThemeProvider theme={theme}>
            <div className="container1 max-width-and-height">
                {authenticated === false && displayLogin
                    ? (
                        // Show the LoginForm if the user is not authenticated and the displayLogin state is true
                        <LoginForm
                            handleSuccess={userHasAuthenticated}
                            showStandardLogin={showStandardModal}
                            showForgotPasswordModal={showForgotPassword}
                            showVerifyModal={showVerified}
                            userForgotComplete={userComfirmPassChange}
                            userClickForgotPasswordLink={userClickedForgotPasswordLink}
                            userVerifed={userVerifed}
                            logoImage="./cybertwin_logo.png"
                        />
                    ) :
                    (
                        // Show the login popup, share page, file picker modal, and Unity component if the user is authenticated or the login form is hidden
                        <>
                            {displayUnityApp === false && (
                                <div id="loginPopup"
                                    style={{
                                        opacity: companyLogoFound
                                            ? '1'
                                            : '0',
                                    }}>
                                    <div
                                        id="loginBackGround"
                                        style={
                                            loginBackGroundStyles
                                        }
                                        className="flex flex-row jcontainer"

                                    >
                                        <div
                                            className="fadeIn"
                                            id="left-side-login-screen"
                                            style={{
                                                opacity:
                                                    spaceName && companyLogoUrl
                                                        ? '1'
                                                        : '0',
                                            }}
                                        >
                                            <img
                                                id="ccompany_logo"
                                                src={companyLogoUrl}
                                                style={{
                                                    opacity:
                                                        companyLogoFound
                                                            ? '1'
                                                            : '0',
                                                }}
                                            />
                                            <h2>{spaceName}</h2>
                                            <img
                                                id="cybertwin_logo"
                                                src={cybertwin_logo}
                                            />
                                        </div>

                                        <CircularLoader
                                            loadingProgress={1}
                                            loadingValue={100}
                                            style={{
                                                opacity:
                                                    unityIsLoaded
                                                        ? '1'
                                                        : '0',
                                            }}
                                        >
                                            <button onClick={handlePlayBtn}>
                                                <LoadedArrowIcon />
                                            </button>
                                        </CircularLoader>



                                        <div
                                            className="flex flex-row fadeIn"
                                            id="share-icon-section"
                                            style={{
                                                opacity: '1'
                                            }}
                                        >

                                            <ShareIconButton
                                                onClick={() =>
                                                    setDisplayShareBtn(
                                                        (isSharebtnClicked) =>
                                                            !isSharebtnClicked
                                                    )
                                                }
                                            >
                                                <ShareSpaceButton />
                                            </ShareIconButton>
                                        </div>
                                    </div>

                                    {displayLogin ? (
                                        <LoginForm
                                            handleSuccess={userHasAuthenticated}
                                        />
                                    ) : null}
                                </div>
                            )}

                            {displayShareBtn ? (
                                <SharePage
                                    handleClose={() => setDisplayShareBtn(false)}
                                    webPage={window.location.href}
                                    sharedKeyFromSpace={sharedKey}
                                    loadedKeyFromUrl={loadedKey}
                                />
                            ) : null}

                            {displayFgFilePopup ? (
                                <FilePickerModal
                                    acceptTypes={fgFileAcceptTypes}
                                    handleSelection={fgHandleFilesSelection}
                                    handleHide={fgHandleHide}
                                />
                            ) : null}


                        </>
                    )
                }
                <Unity
                    className="unity max-width-and-height"
                    unityProvider={unityProvider}
                    // do not set a tab index (and therefore make focusable) until the Unit app is displayed
                    tabIndex={displayUnityApp ? 1 : 0}
                />

            </div>
        </ThemeProvider >
    );
}



export default App;
